import { environment } from 'src/environments/environment';

export type CubeDialerTransport = 'sdk' | 'iframe';

/** CubeConnector binds to this iframe id */
export const CUBE_SDK_IFRAME_ID = 'webphoneFrame';
/** Legacy SSO / postMessage webphone iframe. */
export const CUBE_IFRAME_ID = 'cubeWebphoneFrame';

export function getCubeDialerTransport(): CubeDialerTransport {
  const mode = (environment as { cube_dialer_mode?: string }).cube_dialer_mode;
  if (mode === 'sdk' || mode === 'iframe') {
    return mode;
  }
  return (environment as { cube_sdk?: boolean }).cube_sdk ? 'sdk' : 'iframe';
}

/** True when telephony is CubeConnector methods, not iframe postMessage. */
export function shouldUseCubeSdk(): boolean {
  return getCubeDialerTransport() === 'sdk';
}

export function getCubeBridgeIframeId(): string {
  return shouldUseCubeSdk() ? CUBE_SDK_IFRAME_ID : CUBE_IFRAME_ID;
}
